export enum DATA_QA {
  ROOT = 'set-campaign-draft',
  CANCEL = 'set-campaign-draft__cancel',
  CONFIRM = 'set-campaign-draft__confirm',
}
